import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface CTAButtonProps {
  label: string;
  sublabel?: string;
  size?: 'md' | 'lg';
  variant?: 'solid' | 'outline';
  id?: string;
}
export function CTAButton({
  label,
  sublabel,
  size = 'lg',
  variant = 'solid',
  id
}: CTAButtonProps) {
  const base = 'group flex w-full items-center justify-center gap-2 rounded-2xl text-center font-black uppercase tracking-tight transition-[transform,background-color,box-shadow] duration-150 ease-out active:scale-[0.98] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-400/50';
  const sizes = size === 'lg' ? 'px-5 py-4 text-[15px] leading-tight sm:text-lg' : 'px-4 py-3.5 text-[14px] leading-tight sm:text-base';
  const variants = variant === 'solid' ? 'bg-brand-500 text-ink-950 shadow-[0_10px_30px_-8px_rgba(23,195,178,0.7)] hover:bg-brand-400' : 'border-2 border-brand-500 bg-ink-900 text-brand-200 hover:bg-ink-800';
  return <div className="w-full" id={id} data-id="element-22" data-mp="19ahcgr8m8myr">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${sizes} ${variants}`} data-id="element-23" data-mp="1dai3dbcwiqmp">
        <span className="text-balance" data-id="element-24" data-mp="1i8t9bb02sgzn">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-25" data-mp="1n8ecjxma3bi6" />
      </a>
      {sublabel && <p className="mt-2 text-center text-xs font-medium text-white/50" data-id="element-26" data-mp="1w9458sg8slro">{sublabel}</p>}
    </div>;
}